import { render, staticRenderFns } from "./uploadInvoiceDetails.vue?vue&type=template&id=1274c51c&scoped=true"
import script from "./uploadInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./uploadInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./uploadInvoiceDetails.vue?vue&type=style&index=0&id=1274c51c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274c51c",
  null
  
)

export default component.exports